import { createContext } from "react";
const BreadcumbContext = createContext();

export default BreadcumbContext;
